import UINotifications from './Component';

export default UINotifications;